import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  acceptWorkAssignment,
  getWorkAssignmentByCurrentRecruiterAndJob,
  IJob,
  IWorkAssignment,
} from 'wisestep-api';
import { WsIconText, WsTypoColors, WsColors, WsTypoVariants, Button } from 'wisestep-base';

import { failed, success } from '../../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../../utils/NotificationStore';

interface IAssignJobProps {
  job: IJob;
}

const AcceptJob = ({ job }: IAssignJobProps) => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [assignmentData, setAssignmentData] = useState<IWorkAssignment | null>(null);

  useEffect(() => {
    const getAssignments = async () => {
      if (job.id) {
        const api = await getWorkAssignmentByCurrentRecruiterAndJob(job.id);
        const assignment: IWorkAssignment = api.data;
        setAssignmentData(assignment);
      }
    };
    getAssignments();
  }, [job.id]);

  const acceptJobAssignment = async () => {
    try {
      if (assignmentData?.id && assignmentData?.recruiterId) {
        await acceptWorkAssignment(
          assignmentData?.id,
          assignmentData?.team?.id ?? assignmentData?.recruiterId
        );
        setAssignmentData({ isAccepted: true });
        setNotification(success('Assignment accepted successfully. You can start working now.'));
      } else {
        setNotification(failed('Something went wrong, Please try again !!'));
      }
    } catch (e) {
      setNotification(failed('Assignment got failed, Please try again !!'));
    }
  };

  const isJobToBeAccepted =
    !job?.isClosedForAssigningRecruiters &&
    assignmentData?.assignedBy &&
    !assignmentData?.isAccepted &&
    !assignmentData?.isClosed;

  const text = job?.isClosedForAssigningRecruiters
    ? `Job is Closed`
    : assignmentData?.isAccepted
    ? `Job is accepted`
    : isJobToBeAccepted
    ? `You haven't accepted this job yet. Click Accept Job to proceed with candidate
    mapping`
    : `This Job is not Assigned to you . Please contact the Job Admin team`;
  return (
    <>
      <Grid py={2} sx={{ background: WsColors.Yellow200, borderRadius: 2, height: 57 }}>
        <Box px={4} display="flex" justifyContent="space-between">
          <WsIconText
            icon={<InfoOutlinedIcon sx={{ color: WsColors.Yellow600, height: 18, width: 18 }} />}
            text={`${text}`}
            textColor={WsTypoColors.YELLOWDARK}
            textSize={WsTypoVariants.BODY1}
          />
          {isJobToBeAccepted && (
            <Button
              sx={{
                backgroundColor: WsColors.Yellow600,
                color: 'white',
                '&:hover': {
                  backgroundColor: WsColors.BackGroundYellow,
                },
              }}
              onClick={acceptJobAssignment}
            >
              Accept Job
            </Button>
          )}
        </Box>
      </Grid>
    </>
  );
};

export default AcceptJob;
